import React from "react";
import { checkmarkTheme } from "../checkboxTheme";
import { CheckmarkStyled } from "../styled/CheckmarkStyled";
export const Checkmark = props => {
  return /*#__PURE__*/React.createElement(CheckmarkStyled, {
    size: checkmarkTheme.size[props.size](props.themeMode)
  }, getSvg(props));
};
const ursaIndeterminate = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 10h8",
  stroke: "currentColor",
  strokeWidth: "1.75",
  strokeLinecap: "round"
}));
const ursaCheck = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "m6 9.875 2.75 2.75L14 7.375",
  stroke: "currentColor",
  strokeWidth: "1.75",
  strokeLinecap: "round"
}));
const lodestarIndeterminate = /*#__PURE__*/React.createElement("svg", {
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("rect", {
  x: "4",
  y: "8.5",
  width: "12",
  height: "3",
  rx: "1.5",
  fill: "currentColor"
}));
const lodestarCheck = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.7 4.41a1.49 1.49 0 0 1 2.09-.47c.66.44.86 1.32.45 2l-5.88 9.79c-.41.68-1.36.77-1.9.19l-4.52-4.94c-.54-.59-.52-1.5.04-2.06.6-.6 1.59-.58 2.16.04l2.91 3.18 4.65-7.73Z",
  fill: "currentColor"
}));

// using the following icons instead of anything from @smartsheet/ursa-icons because they have
// different sizing/pattern for this one-off situation

const ursaStar = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.756.788c.497-1.052 1.991-1.052 2.489 0l1.42 3.006 3.138.416c1.109.146 1.586 1.482.832 2.3L11.342 9l.627 3.366c.208 1.118-.952 2-1.973 1.484L7 12.34l-2.996 1.51c-1.02.515-2.18-.366-1.973-1.484L2.658 9 .366 6.51c-.755-.818-.277-2.154.831-2.3l3.137-.416L5.756.788Z"
}));
const ursaStarEmpty = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m7 11.557-3.31 1.67a.677.677 0 0 1-.97-.731l.69-3.711L.88 6.038a.679.679 0 0 1 .41-1.133l3.514-.466 1.585-3.35a.676.676 0 0 1 1.223 0l1.584 3.35 3.515.466c.544.072.781.729.409 1.133l-2.53 2.747.69 3.71a.677.677 0 0 1-.969.731l-3.31-1.67Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 1.431 5.437 4.737a.7.7 0 0 1-.54.395l-3.474.46 2.502 2.717a.7.7 0 0 1 .173.602l-.682 3.668 3.269-1.648a.7.7 0 0 1 .63 0l3.27 1.648-.683-3.668a.7.7 0 0 1 .173-.602l2.503-2.717-3.474-.46a.7.7 0 0 1-.54-.395L7 1.431ZM5.756.788c.497-1.052 1.991-1.052 2.489 0l1.42 3.006 3.138.416c1.109.146 1.586 1.482.832 2.3L11.342 9l.627 3.366c.208 1.118-.952 2-1.973 1.484L7 12.34l-2.996 1.51c-1.02.515-2.18-.366-1.973-1.484L2.658 9 .366 6.51c-.755-.818-.277-2.154.831-2.3l3.137-.416L5.756.788Z"
}));
const ursaFlag = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "14",
  fill: "none",
  viewBox: "0 0 12 14"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.661 0a.7.7 0 0 1 .7.7v.589h7.261c1.235 0 1.876 1.472 1.036 2.376L9.11 5.33l-.003.004-.001.006v.005l.004.004 1.547 1.665c.84.904.199 2.376-1.036 2.376h-7.26v3.91a.7.7 0 1 1-1.4 0V.7a.7.7 0 0 1 .7-.7Z"
}));
const ursaFlagEmpty = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 14"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 8.5V2h8.5L8.289 5.25 10.5 8.5H2Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.661 0a.7.7 0 0 1 .7.7v.589h7.261c1.235 0 1.876 1.472 1.036 2.376L9.11 5.33l-.003.004-.001.006v.005l.004.004 1.547 1.665c.84.904.199 2.376-1.036 2.376h-7.26v3.91a.7.7 0 1 1-1.4 0V.7a.7.7 0 0 1 .7-.7Zm.7 7.99H9.63l.005-.008c.002-.004.002-.009.002-.009l-.005-.006-1.547-1.665a1.414 1.414 0 0 1 0-1.925l1.547-1.665.005-.006s0-.005-.002-.009L9.63 2.69H2.362V7.99Z",
  clipRule: "evenodd"
}));
const getSvg = props => {
  if (props.appearance === "check") {
    switch (props.themeMode) {
      case "ursa-light":
      case "ursa-dark":
        // Note that these svgs apply their color via stroke, not fill.
        return props.checkedState === "indeterminate" ? ursaIndeterminate : ursaCheck;
      case "oldestar":
      case "lodestar-light":
      default:
        // Note that these svgs apply their color via fill, not stroke.
        return props.checkedState === "indeterminate" ? lodestarIndeterminate : lodestarCheck;
    }
  } else if (props.appearance === "flag") {
    return props.checkedState === "checked" ? ursaFlag : ursaFlagEmpty;
  } else if (props.appearance === "star") {
    return props.checkedState === "checked" ? ursaStar : ursaStarEmpty;
  }
};
//# sourceMappingURL=Checkmark.js.map